import { forwardRef } from 'react'
import { type FontInkPt, caretVerticalBox } from '../helpers/caret-geometry'

/**
 * The blinking caret bar. The caller keys it on the caret's position, so moving the caret
 * remounts it and restarts the blink from solid; the device-pixel x snap is applied to the
 * forwarded ref by `useShapeTextCaret`.
 */
export const ShapeTextCaret = forwardRef<
  HTMLDivElement,
  {
    caret: { x: number; yTop: number; rowHeight: number }
    widthPt: number
    ink: FontInkPt
    baselinePt: number | undefined
    /** Overrides `caret.rowHeight` for a row with no text — see `useShapeTextCaret`. */
    rowHeightPt: number | undefined
    shapeHeight: number
  }
>(({ caret, widthPt, ink, baselinePt, rowHeightPt, shapeHeight }, ref) => (
  <div
    ref={ref}
    className="absolute bg-black pointer-events-none shape-text-caret-blink"
    style={{
      left: caret.x,
      width: widthPt,
      // Positioned on the row's ink box and clamped into the outline's band — see
      // `caretVerticalBox`.
      ...caretVerticalBox(
        { yTop: caret.yTop, rowHeight: rowHeightPt ?? caret.rowHeight },
        ink,
        shapeHeight,
        baselinePt
      ),
    }}
  />
))

ShapeTextCaret.displayName = 'ShapeTextCaret'
